import AdminProfile from "./AdminProfile";
import Layout from "../../components/Layout";
import { useUserState } from "../../context/UserContext";
import UserProfile from "./UserProfile";
import StudentProfile from "./StudentProfile";
// import Box from "@mui/material/Box";
// import useStyles from "./styles";
import GuardianProfile from "./GuardianProfile";

const Profile = () => {
  const { userRole } = useUserState();

  return (
    <Layout children={
      <>
        {userRole?.role_type === "school_admin" ? (
          <AdminProfile />
        ) : userRole?.role_type === "employee" ? <UserProfile /> : userRole?.role_type === "guardian" ? <GuardianProfile /> : <StudentProfile />}
      </>
    }
    />
  );
};

export default Profile;
